export const defaultColors = [
  "#003f5c",
  "#58508d",
  "#bc5090",
  "#ff6361",
  "#ffa600",
]

export const pickColor = (index: number) => {
  const colors = defaultColors
  return colors[index % colors.length]
}

export function darkenColor(hexColor: string, factor: number): string {
  // Validate hex color input
  if (!/^#([0-9A-F]{3}){1,2}$/i.test(hexColor)) {
    throw new Error("Invalid hex color format")
  }

  // Expand shorthand hex format (e.g., #abc -> #aabbcc)
  if (hexColor.length === 4) {
    hexColor = `#${hexColor[1]}${hexColor[1]}${hexColor[2]}${hexColor[2]}${hexColor[3]}${hexColor[3]}`
  }

  // Extract RGB values
  const r: number = parseInt(hexColor.slice(1, 3), 16)
  const g: number = parseInt(hexColor.slice(3, 5), 16)
  const b: number = parseInt(hexColor.slice(5, 7), 16)

  // Darken each color component
  const darken = (color: number): number =>
    Math.max(0, Math.min(255, Math.floor(color * factor)))

  const newR: string = darken(r).toString(16).padStart(2, "0")
  const newG: string = darken(g).toString(16).padStart(2, "0")
  const newB: string = darken(b).toString(16).padStart(2, "0")

  // Return the new darker color
  return `#${newR}${newG}${newB}`
}
